import { render, staticRenderFns } from "./BlockCertificateAdvertising.vue?vue&type=template&id=081a5b89&scoped=true&"
import script from "./BlockCertificateAdvertising.vue?vue&type=script&lang=js&"
export * from "./BlockCertificateAdvertising.vue?vue&type=script&lang=js&"
import style0 from "./BlockCertificateAdvertising.vue?vue&type=style&index=0&id=081a5b89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a5b89",
  null
  
)

export default component.exports